// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.record-state {
  height: 40px;
  width: 240px;
  bottom: 0px;
  position: fixed;
  z-index: 1042;
  color: #000;
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
  padding-left: 1vw;
}

.nav-full-width {
  width: 100%;
}
.nav-full-width li {
  padding-left: 10px;
  padding-right: 10px;
}
.nav-full-width li p {
  margin-top: 5px;
  margin-bottom: 0px;
}
.nav-full-width .psy-name {
  border-left: 1px dashed rgba(255, 255, 255, 0.15);
  width: 10%;
  border-right: 1px dashed rgba(255, 255, 255, 0.15);
}
.nav-full-width .study-sponsored {
  width: 10%;
  border-right: 1px dashed rgba(255, 255, 255, 0.15);
}
.nav-full-width .title {
  width: 60%;
  border-right: 1px dashed rgba(255, 255, 255, 0.15);
}
.nav-full-width .request-type {
  width: 10%;
  border-right: 1px dashed rgba(255, 255, 255, 0.15);
}
.nav-full-width .review {
  width: 10%;
  border-left: 1px dashed rgba(255, 255, 255, 0.15);
  height: 65px;
}
.nav-full-width .review .normal-more-review {
  font-size: 13px;
  font-weight: 400;
}

.normal {
  font-size: 10px;
  font-weight: 500;
  margin-top: 8px !important;
}

.normal-more {
  font-size: 13px;
  font-weight: 400;
  margin-top: -3px !important;
}

.normal-more-review {
  margin-top: 7px !important;
  text-transform: uppercase;
}

.btn-primary {
  background-color: #4285f4 !important;
  color: #fff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0069d9 !important;
  border-color: #0062cc;
}

.check-popover {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
}
.check-popover .popover {
  position: absolute;
  left: 50%;
  bottom: 4px;
  margin-left: -100px;
}

.inactive-button {
  opacity: 0.7;
}
.inactive-button.activate-button {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/common/ext-header/ext-header.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AACA;EACI,WAAA;AAEJ;AAAI;EAKI,kBAAA;EACA,mBAAA;AAFR;AAHQ;EACI,eAAA;EACA,kBAAA;AAKZ;AAAI;EACI,iDAAA;EACA,UAAA;EACA,kDAAA;AAER;AAAI;EACI,UAAA;EACA,kDAAA;AAER;AAAI;EACI,UAAA;EACA,kDAAA;AAER;AAAI;EACI,UAAA;EACA,kDAAA;AAER;AAAI;EACI,UAAA;EACA,iDAAA;EACA,YAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;AAGZ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;AAEJ;;AAAA;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;AAGJ;;AADA;EACI,0BAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,oCAAA;EACA,WAAA;AAKJ;;AAHA;EACI,WAAA;EACA,oCAAA;EACA,qBAAA;AAMJ;;AAHA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AAMJ;AALI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAOR;;AAHA;EACI,YAAA;AAMJ;AALI;EACI,UAAA;AAOR","sourcesContent":[".record-state{\r\n    height: 40px;\r\n    width: 240px;\r\n    bottom: 0px;\r\n    position: fixed;\r\n    z-index: 1042;\r\n    color: #000;\r\n    background: #fff;\r\n    border-top: 1px solid #ddd;\r\n    padding: 10px;\r\n    font-size: 12px;\r\n    padding-left: 1vw;\r\n}\r\n.nav-full-width{\r\n    width: 100%;\r\n    \r\n    li{\r\n        p{\r\n            margin-top: 5px; \r\n            margin-bottom: 0px;\r\n        }\r\n        padding-left: 10px;\r\n        padding-right: 10px;\r\n    }\r\n    .psy-name{\r\n        border-left: 1px dashed rgba(255, 255, 255, 0.15);\r\n        width: 10%;\r\n        border-right:1px dashed rgba(255, 255, 255, 0.15);\r\n    }\r\n    .study-sponsored{\r\n        width: 10%;\r\n        border-right:1px dashed rgba(255, 255, 255, 0.15);\r\n    }\r\n    .title{\r\n        width: 60%;\r\n        border-right:1px dashed rgba(255, 255, 255, 0.15);\r\n    }\r\n    .request-type{\r\n        width: 10%;\r\n        border-right:1px dashed rgba(255, 255, 255, 0.15);\r\n    }   \r\n    .review{\r\n        width: 10%;\r\n        border-left:1px dashed rgba(255, 255, 255, 0.15);\r\n        height: 65px;\r\n        .normal-more-review{\r\n            font-size: 13px;\r\n            font-weight: 400;\r\n        }\r\n    }\r\n}\r\n.normal {\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    margin-top: 8px !important;\r\n}\r\n.normal-more {\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    margin-top: -3px !important;\r\n}\r\n.normal-more-review{\r\n    margin-top:7px !important; \r\n    text-transform: uppercase;\r\n}\r\n.btn-primary {\r\n    background-color: #4285f4!important;\r\n    color: #fff;\r\n}\r\n.btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #0069d9 !important;\r\n    border-color: #0062cc;\r\n}\r\n\r\n.check-popover {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    height: 1px;\r\n    .popover {\r\n        position: absolute;\r\n        left: 50%;\r\n        bottom: 4px;\r\n        margin-left: -100px;\r\n    }\r\n}\r\n\r\n.inactive-button {\r\n    opacity: 0.7;\r\n    &.activate-button {\r\n        opacity: 1;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
